import React from 'react';
import { Descriptions } from 'antd';
import { formatAuditDateTime, formatAuditUserName } from '../lib/format';

export interface AuditPropertiesValues {
  createdAtUtc: string;
  createdByDisplayName?: string | null;
  createdByUserId?: string | null;
  lastModifiedAtUtc?: string | null;
  modifiedByDisplayName?: string | null;
  modifiedByUserId?: string | null;
}

interface AuditPropertiesProps {
  values: AuditPropertiesValues;
  className?: string;
  style?: React.CSSProperties;
}

const AuditProperties: React.FC<AuditPropertiesProps> = ({ values, className, style }) => (
  <Descriptions
    className={className}
    style={style}
    column={2}
    size="small"
    title="Audit Properties"
  >
    <Descriptions.Item label="Created At">
      {formatAuditDateTime(values.createdAtUtc)}
    </Descriptions.Item>
    <Descriptions.Item label="Created By">
      {formatAuditUserName(values.createdByDisplayName, values.createdByUserId)}
    </Descriptions.Item>
    <Descriptions.Item label="Last Modified">
      {formatAuditDateTime(values.lastModifiedAtUtc)}
    </Descriptions.Item>
    <Descriptions.Item label="Modified By">
      {formatAuditUserName(values.modifiedByDisplayName, values.modifiedByUserId)}
    </Descriptions.Item>
  </Descriptions>
);

export default AuditProperties;
